import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'No Transactions Found',
  description:
    'Looks like there’s no data to display yet. Expenses made by your accounts and cards will appear here.',
})
